<template>
  <section id="testimonials" v-if="testimonials.children.length > 0">
    <h1 class="no-pad">Testimonials</h1>
    <div v-for="subpage in testimonials.children" :key="subpage.id" class="testmonial small">
      <p>«{{ subpage.citation }}»<br><br>
        {{ subpage.title }}</p>
    </div>
  </section>
</template>
<script>
export default {
  name: 'testimonials',
  computed: {
    testimonials() {
      return this.$store.getters.getPageByUID('testimonials')
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';
#testimonials {
    // padding-top: 0;
    border-bottom: 2px solid $font-color;
    margin-bottom: $gap * 4;
    @media only screen and (max-width: $phone) {
        padding-bottom: $gap / 2;
        border-bottom: 1px solid $font-color;
    }
    .testmonial {
        padding: $gap / 2 0;
        // border-bottom: 2px solid $font-color;
        @media only screen and (max-width: $phone) {
            padding: $gap / 4 0;
            // border-bottom:1px solid $font-color;
        }
        p {
            margin-bottom: $gap;
            @media only screen and (max-width: $phone) {
                margin-bottom: $gap / 2;
            }
            &:last-child {
                margin-bottom: 0;
            }
            &.small {
                @media only screen and (min-width:600px) {
                    font-size: $font-size / 3;
                    line-height: 1.15;
                }
            }
        }
    }
}
</style>
